import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import { Grid, GridCell } from 'rmwc/Grid';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { Link } from 'react-router-dom'

class AdminCouponHome extends Component{
	render() {
		return (
			<div>
        <Card style={{padding: '25px'}}>
        <Grid>
          <GridCell span="12">
            <Typography use="headline5">Coupon Details</Typography>
          </GridCell>
        </Grid>
				<Grid>
					<GridCell span="6"><Typography style={{color: 'blue',textDecorationLine: 'underline'}} use="headline6"><Link to="/portal/app/admin/coupons/add">Add Coupons</Link></Typography></GridCell>
					<GridCell span="6"><Typography style={{color: 'blue',textDecorationLine: 'underline'}} use="headline6"><Link to="/portal/app/admin/coupons/search">Search Coupons</Link></Typography></GridCell>
					<GridCell span="6"><Typography style={{color: 'blue',textDecorationLine: 'underline'}} use="headline6"><Link to="/portal/app/admin/coupons/view">View Coupons</Link></Typography></GridCell>
          <GridCell span="6"><Typography style={{color: 'blue',textDecorationLine: 'underline'}} use="headline6"><Link to="/portal/app/admin/coupons/institution">Allocate Coupons to Institutions</Link></Typography></GridCell>
          <GridCell span="6"><Typography style={{color: 'blue',textDecorationLine: 'underline'}} use="headline6"><Link to="/portal/app/admin/coupons/user_details">View Allocated Coupons for Users</Link></Typography></GridCell>
          <GridCell span="6"><Typography style={{color: 'blue',textDecorationLine: 'underline'}} use="headline6"><Link to="/portal/app/admin/coupons/coupon_allocation_status">Coupons Allocation Status</Link></Typography></GridCell>
          <GridCell span="6"><Typography style={{color: 'blue',textDecorationLine: 'underline'}} use="headline6"><Link to="/portal/app/admin/coupons/retail">Allocate Coupon To Retails (Course Correction)</Link></Typography></GridCell>
				</Grid>
        </Card>
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCouponHome);


// WEBPACK FOOTER //
// ./src/views/admin/AdminCouponHome.jsx